const ARROW_BUTTON_HEIGHT = 40;
// include space and remove extra padding
const SPACE = 20 - 4;

type RequiredSizes = 'm' | 'l' | 'xl';

type OptionalSizes =
  | {
      _: number;
    }
  | {
      s: number;
    };

type PictureHeight = {
  [key in RequiredSizes]: number;
} & OptionalSizes;

export const getArrowTopPositionInSlider = (pictureHeight: PictureHeight) =>
  Object.fromEntries(
    Object.entries(pictureHeight).map(([key, value]) => [
      key,
      `${value - ARROW_BUTTON_HEIGHT - SPACE}px`,
    ]),
  );
